import { combineReducers, Reducer } from 'redux';
import * as constants from './reports.constants';
import { isActionOfType } from '../../../../utils/action.utils';
import {
  IReportsPageState,
  IStoreMeetingReport,
  IClearMeetingReport,
  IMeetingReportsPageAction,
  IClearUserReports,
  IStoreUserReports,
  IReport,
} from './reports.types';

const initialState: IReportsPageState = {
  byUserGlobal: {},
  byMeeting: {},
};

const byMeeting: Reducer<IReport['byMeeting'], IStoreMeetingReport | IClearMeetingReport> = (
  state = initialState.byMeeting,
  action,
) => {
  if (isActionOfType<IStoreMeetingReport>(action, constants.STORE_MEETING_REPORTS)) {
    return action.payload;
  } else if (isActionOfType<IClearMeetingReport>(action, constants.CLEAR_MEETING_REPORTS)) {
    return initialState.byMeeting;
  }

  return state;
};

const byUserGlobal: Reducer<IReport['byUserGlobal'], IStoreUserReports | IClearUserReports> = (
  state = initialState.byUserGlobal,
  action,
) => {
  if (isActionOfType<IStoreUserReports>(action, constants.STORE_USER_REPORTS)) {
    return action.payload;
  } else if (isActionOfType<IClearUserReports>(action, constants.CLEAR_USER_REPORTS)) {
    return initialState.byUserGlobal;
  }

  return state;
};

export const reportsPageReducer: Reducer<IReportsPageState, IMeetingReportsPageAction> = combineReducers({
  byMeeting,
  byUserGlobal,
});
